import { render, staticRenderFns } from "./MypageFavoriteTeamSelectPane.vue?vue&type=template&id=5e046efc&scoped=true"
import script from "./MypageFavoriteTeamSelectPane.vue?vue&type=script&lang=ts"
export * from "./MypageFavoriteTeamSelectPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageFavoriteTeamSelectPane.vue?vue&type=style&index=0&id=5e046efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e046efc",
  null
  
)

export default component.exports